import { Controller } from "stimulus";
import { DirectUpload } from "@rails/activestorage";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [
    "form",
    "uploader",
    "uploading",
    "failed",
    "size",
    "format",
    "saved",
  ];

  connect() {
    // This controller is used both in NU and NgAdmin, therefore we need to take to classes for hiding into account
    if (this.uploadingTarget.classList.contains('hidden')) {
      this.classForHiding = 'hidden';
    } else {
      this.classForHiding = 'js-hidden';
    }

    this.uploaderTarget.addEventListener('change', (_event) => {
      Array.from(this.uploaderTarget.files).forEach(file => this.uploadFile(file))
    })
  }

  uploadFile(file) {
    this.displayUploading();

    // file_field direct_upload: true provides the data-direct-upload-url
    const url = this.uploaderTarget.dataset.directUploadUrl;
    const upload = new DirectUpload(file, url)

    if (upload.file.size === 0) {
      this.displaySizeError();
      return false;
    }

    if (!this.isAllowedType(upload.file)) {
      this.displayFormatError();
      return false;
    }

    upload.create((error, blob) => {
      if (error) {
        this.displayError();
      } else {
        this.updateUser(blob.signed_id);
      }
    })
  }

  isAllowedType(file) {
    // NgAdmin's uploader has no accept list, so it falls back to any image type
    const accept = this.uploaderTarget.accept;
    return accept ? accept.split(',').includes(file.type) : file.type.match('image');
  }

  deleteAvatar(event) {
    event.stopPropagation();

    Rails.confirm(null, event.currentTarget, null, {
      confirmCallback: () => {
        const formData = new FormData();
        formData.append('user[remove_avatar]', '1');

        Rails.ajax({
          url: this.formTarget.action,
          type: 'patch',
          data: formData,
          dataType: 'script',
          error: () => {
            this.displayError();
          }
        });
      }
    });
  }

  updateUser(signed_blob_id) {
    const formData = new FormData();
    formData.append(
      "user[signed_blob_id]",
      signed_blob_id
    );

    Rails.ajax({
      url: this.formTarget.action,
      type: "patch",
      data: formData,
      dataType: "script",
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      },
      success: () => {
        this.displaySuccess();
      },
      error: (_response, _statusText, xhr) => {
        if (xhr.status === 422) {
          this.displayFormatError();
        } else {
          this.displayError();
        }
      }
    });
  }

  displayUploading() {
    this.failedTarget.classList.add(this.classForHiding);
    this.formatTarget.classList.add(this.classForHiding);
    this.sizeTarget.classList.add(this.classForHiding);
    this.uploadingTarget.classList.remove(this.classForHiding);
  }

  displayError() {
    this.uploadingTarget.classList.add(this.classForHiding);
    this.formatTarget.classList.add(this.classForHiding);
    this.sizeTarget.classList.add(this.classForHiding);
    this.failedTarget.classList.remove(this.classForHiding);
  }

  displaySizeError() {
    this.uploadingTarget.classList.add(this.classForHiding);
    this.formatTarget.classList.add(this.classForHiding);
    this.sizeTarget.classList.remove(this.classForHiding);
  }

  displayFormatError() {
    this.uploadingTarget.classList.add(this.classForHiding);
    this.sizeTarget.classList.add(this.classForHiding);
    this.formatTarget.classList.remove(this.classForHiding);
  }

  displaySuccess() {
    this.uploadingTarget.classList.add(this.classForHiding);
    this.savedTarget.classList.remove(this.classForHiding);

    setTimeout(
      function () {
        this.savedTarget.classList.add(this.classForHiding);
      }.bind(this),
      8000
    );
  }
}
